import request from '@/utils/request';
import { datasetEndpoint, endpoints } from '@/constants/urls';

const dictionaries = (dataset, page, pageSize) => (
  request({
    url: endpoints.DICTIONARIES,
    params: { page, pageSize, dataset },
    method: 'GET',
  })
);

const datasetDictionaries = (
  filter,
  code,
  dataExists,
  page,
  pageSize,
) => (
  request({
    url: `${datasetEndpoint(code)}/dictionaries`,
    params: {
      filter, page, pageSize, dataExists,
    },
    method: 'GET',
  })
);

const DictionariesService = {
  datasetDictionaries,
  dictionaries,
};

export default DictionariesService;
